import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {API_ROOT} from "../../../../baseUrls";

function ProfilePhotoDisplay({ user, mindfile }) {
  const updatingAvatar = mindfile.picturesUploading > 0;
  const [avatarUrl, setAvatarUrl] = useState("");

  useEffect(() => {
    if (updatingAvatar
          || typeof(mindfile) === 'undefined' || !mindfile
          || typeof(mindfile.id) === 'undefined' || !mindfile.id) {
      setAvatarUrl("");
    } else {
      setAvatarUrl(
        `${API_ROOT}/mindfiles/${mindfile.id}/avatar/thumbnail?size=256&ts=${mindfile.timestamp}`
      );
    }
  }, [mindfile, updatingAvatar]);

  return (
    <div style={{ display: "flex", }}>
        <div
          style={{
            display: "flex",
            borderRadius: "4px",
            backgroundColor: "#003e58",
            justifyContent: "center",
            alignItems: "center",
            padding: 4,
          }}
        >
          {avatarUrl === "" ? <div id="profilePhotoDisplay">Not Set.</div>
            : <img id="profilePhotoDisplay" src={avatarUrl} alt={`${mindfile?.name}`} title={`${mindfile?.name}`} />
          }
        </div>
    </div>
  );
}

const mapStateToProps = state => ({
  user: state.auth,
  mindfile: state.mindfile,
});

export default connect(mapStateToProps)(ProfilePhotoDisplay);
